// src/pages/Survey.js
import React, { useState } from 'react';
import AnimatedStep from '../components/AnimatedStep';
import { post } from '../services/ApiService';

// Import all 35 steps
import SurveyStepOne from '../components/SurveySteps/SurveyStepOne';
import SurveyStepTwo from '../components/SurveySteps/SurveyStepTwo';
import SurveyStepThree from '../components/SurveySteps/SurveyStepThree';
import SurveyStepFour from '../components/SurveySteps/SurveyStepFour';
import SurveyStepFive from '../components/SurveySteps/SurveyStepFive';
import SurveyStepSix from '../components/SurveySteps/SurveyStepSix';
import SurveyStepSeven from '../components/SurveySteps/SurveyStepSeven';
import SurveyStepEight from '../components/SurveySteps/SurveyStepEight';
import SurveyStepNine from '../components/SurveySteps/SurveyStepNine';
import SurveyStepTen from '../components/SurveySteps/SurveyStepTen';
import SurveyStepEleven from '../components/SurveySteps/SurveyStepEleven';
import SurveyStepTwelve from '../components/SurveySteps/SurveyStepTwelve';
import SurveyStepThirteen from '../components/SurveySteps/SurveyStepThirteen';
import SurveyStepFourteen from '../components/SurveySteps/SurveyStepFourteen';
import SurveyStepFifteen from '../components/SurveySteps/SurveyStepFifteen';
import SurveyStepSixteen from '../components/SurveySteps/SurveyStepSixteen';
import SurveyStepSeventeen from '../components/SurveySteps/SurveyStepSeventeen';
import SurveyStepEighteen from '../components/SurveySteps/SurveyStepEighteen';
import SurveyStepNineteen from '../components/SurveySteps/SurveyStepNineteen';
import SurveyStepTwenty from '../components/SurveySteps/SurveyStepTwenty';
import SurveyStepTwentyOne from '../components/SurveySteps/SurveyStepTwentyOne';
import SurveyStepTwentyTwo from '../components/SurveySteps/SurveyStepTwentyTwo';
import SurveyStepTwentyThree from '../components/SurveySteps/SurveyStepTwentyThree';
import SurveyStepTwentyFour from '../components/SurveySteps/SurveyStepTwentyFour';
import SurveyStepTwentyFive from '../components/SurveySteps/SurveyStepTwentyFive';
import SurveyStepTwentySix from '../components/SurveySteps/SurveyStepTwentySix';
import SurveyStepTwentySeven from '../components/SurveySteps/SurveyStepTwentySeven';
import SurveyStepTwentyEight from '../components/SurveySteps/SurveyStepTwentyEight';
import SurveyStepTwentyNine from '../components/SurveySteps/SurveyStepTwentyNine';
import SurveyStepThirty from '../components/SurveySteps/SurveyStepThirty';
import SurveyStepThirtyOne from '../components/SurveySteps/SurveyStepThirtyOne';
import SurveyStepThirtyTwo from '../components/SurveySteps/SurveyStepThirtyTwo';
import SurveyStepThirtyThree from '../components/SurveySteps/SurveyStepThirtyThree';
import SurveyStepThirtyFour from '../components/SurveySteps/SurveyStepThirtyFour';
import SurveyStepThirtyFive from '../components/SurveySteps/SurveyStepThirtyFive';

function Survey() {
    const [step, setStep] = useState(1);
    const [formData, setFormData] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleNext = (data) => {
        setFormData(prev => ({ ...prev, ...data }));
        if (step === 35) {
            handleSubmit();
        } else {
            setStep(prev => prev + 1);
        }
    };

    const handleBack = () => {
        setStep(prev => Math.max(prev - 1, 1));
    };

    const handleSubmit = async () => {
        setIsSubmitting(true);
        try {
            const res = await post("home/survey/submit", formData);
            if (res.success) {
                setStep(prev => prev + 1); // Move to thank you screen
            } else {
                alert("Submission failed");
            }
        } catch (error) {
            alert("Submission error");
        } finally {
            setIsSubmitting(false);
        }
    };

    const stepProps = {
        onNext: handleNext,
        formData,
        isSubmitting,
    };

    const renderStep = () => {
        switch (step) {
            case 1: return <SurveyStepOne {...stepProps} />;
            case 2: return <SurveyStepTwo {...stepProps} />;
            case 3: return <SurveyStepThree {...stepProps} />;
            case 4: return <SurveyStepFour {...stepProps} />;
            case 5: return <SurveyStepFive {...stepProps} />;
            case 6: return <SurveyStepSix {...stepProps} />;
            case 7: return <SurveyStepSeven {...stepProps} />;
            case 8: return <SurveyStepEight {...stepProps} />;
            case 9: return <SurveyStepNine {...stepProps} />;
            case 10: return <SurveyStepTen {...stepProps} />;
            case 11: return <SurveyStepEleven {...stepProps} />;
            case 12: return <SurveyStepTwelve {...stepProps} />;
            case 13: return <SurveyStepThirteen {...stepProps} />;
            case 14: return <SurveyStepFourteen {...stepProps} />;
            case 15: return <SurveyStepFifteen {...stepProps} />;
            case 16: return <SurveyStepSixteen {...stepProps} />;
            case 17: return <SurveyStepSeventeen {...stepProps} />;
            case 18: return <SurveyStepEighteen {...stepProps} />;
            case 19: return <SurveyStepNineteen {...stepProps} />;
            case 20: return <SurveyStepTwenty {...stepProps} />;
            case 21: return <SurveyStepTwentyOne {...stepProps} />;
            case 22: return <SurveyStepTwentyTwo {...stepProps} />;
            case 23: return <SurveyStepTwentyThree {...stepProps} />;
            case 24: return <SurveyStepTwentyFour {...stepProps} />;
            case 25: return <SurveyStepTwentyFive {...stepProps} />;
            case 26: return <SurveyStepTwentySix {...stepProps} />;
            case 27: return <SurveyStepTwentySeven {...stepProps} />;
            case 28: return <SurveyStepTwentyEight {...stepProps} />;
            case 29: return <SurveyStepTwentyNine {...stepProps} />;
            case 30: return <SurveyStepThirty {...stepProps} />;
            case 31: return <SurveyStepThirtyOne {...stepProps} />;
            case 32: return <SurveyStepThirtyTwo {...stepProps} />;
            case 33: return <SurveyStepThirtyThree {...stepProps} />;
            case 34: return <SurveyStepThirtyFour {...stepProps} />;
            case 35: return <SurveyStepThirtyFive {...stepProps} />;
            default: return null;
        }
    };

    return (
        <div className="container step_form_wrap py-2">
            <div className="row justify-content-center">
                <div className="col-md-8">
                    <div className="step_form_wrap_main_ques">
                        <img
                            src="/assets/logo.png"
                            alt="Crowded Logo"
                            className="logo_steps"
                        />
                        {step <= 35 && (
                            <h5 className="my-4">Step {step} / 35</h5>
                        )}
                        <AnimatedStep stepKey={step}>
                            {renderStep()}
                        </AnimatedStep>
                        <div className="d-flex justify-content-between bk_btn">
                            {step > 1 && step <= 35 && (
                                <button className="btn btn-light btn-light-step px-4" onClick={handleBack}>
                                    Back
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Survey;
